import clsx from 'clsx';
import { LoadingSpinner } from './loading-spinner.tsx';

type Props = {
    className?: string;
};
export const LoadingBlockFullPage: React.FC<Props> = ({ className = '' }) => {
    return (
        <div className={clsx('flex h-full w-full items-center justify-center', className)}>
            <LoadingSpinner />
        </div>
    );
};
